import type { AnomalyStatus, QualityMetric, Sensitivity } from '@/features/quality/types';

/**
 * Plain-language labels so the Data Quality module reads clearly for people who
 * don't know terms like "null_rate" or "anomaly". The technical values are kept
 * on the wire; only what the user sees is friendlier.
 */
export const METRIC_LABELS: Record<QualityMetric, string> = {
  null_rate: 'Blank values',
  distinct_count: 'Different values',
  row_count: 'Number of rows',
  pattern_conformance: 'Correct format',
  freshness_lag: 'Data freshness',
};

export const METRIC_HELP: Record<QualityMetric, string> = {
  null_rate: 'How often this field is left empty',
  distinct_count: 'How many different values appear',
  row_count: 'How many records the table has',
  pattern_conformance: 'How often values match the expected format',
  freshness_lag: 'How recently the data was updated',
};

export const STATUS_LABELS: Record<AnomalyStatus, string> = {
  open: 'Needs review',
  acknowledged: 'Seen',
  resolved: 'Fixed',
};

export const SENSITIVITY_LABELS: Record<Sensitivity, string> = {
  low: 'Relaxed',
  medium: 'Balanced',
  high: 'Strict',
};

export function metricLabel(metric: string): string {
  return (METRIC_LABELS as Record<string, string>)[metric] ?? metric;
}
